// App.jsx
import React, { useRef, createRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { ToastContainer } from 'react-toastify';
import Home from "./pages/Home";
import Onboard from "./pages/Onboard";
import Apps from "./pages/Apps";
import AppDetails from "./pages/AppDetails";
import Error404 from "./pages/Error404";

function App() {
  const location = useLocation();

  const nodeRefMap = useRef(new Map());
  const routeKey = location.key || location.pathname;

  if (!nodeRefMap.current.has(routeKey)) {
    nodeRefMap.current.set(routeKey, createRef());
  }
  const nodeRef = nodeRefMap.current.get(routeKey);

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={routeKey}
        timeout={500}
        unmountOnExit
        classNames="page"
        nodeRef={nodeRef}
      >
        <div ref={nodeRef} className="content">
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/app/:slug" element={<AppDetails />} />
            <Route path="/onboard/:step" element={<Onboard />} />

            <Route path="*" element={<Error404 />} />
          </Routes>
          <ToastContainer />
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default App;
